<div class="modal-body">
  <app-events-table [tab]="tab" [referral]="referral"></app-events-table>
</div>

<div class="modal-footer">
  <button type="button" mdbBtn color="secondary" class="waves-light" aria-label="Close" (click)="modalRef.hide()" mdbWavesEffect>Close</button>
</div>
